import React from 'react';

import { connect } from 'react-redux';

import { useParams } from 'src/router/hooks';
import { BucketState } from 'src/types/state';
import { safeDecodePath } from 'src/utils/path';

import RepositoryDetailsCard from '../../../containers/repository-details-card';
import FileDetailsCard from '../containers/file-details-card';
import { FileTree } from '../types';
import findInDirectory from '../utils/find-in-directory';

const mapStateToProps = (state: BucketState) => ({
  fileTree: state.repository.source.section.fileTree,
});

type FileOrRepoDetailsCardProps = {
  isCollapsed: boolean;
  path?: string;
  fileTree: FileTree | null | undefined;
};

const FileOrRepoDetailsCard = connect(mapStateToProps)(
  (props: FileOrRepoDetailsCardProps) => {
    const { isCollapsed, path, fileTree } = props;

    if (fileTree && fileTree.tree) {
      // If we can't find the file / directory in the tree, we want to fall
      // back on displaying the repository details card (since we already have that datas)
      const treeEntry = path
        ? findInDirectory(fileTree.tree, path)
        : fileTree.tree;
      if (!treeEntry || treeEntry.type !== 'file') {
        return <RepositoryDetailsCard isCollapsed={isCollapsed} />;
      }
    }

    return <FileDetailsCard isCollapsed={isCollapsed} path={path} />;
  }
);

type SourceDetailsCardProps = {
  isCollapsed?: boolean;
};

const SourceDetailsCard = ({ isCollapsed = false }: SourceDetailsCardProps) => {
  const { path } = useParams<{ path?: string }>();

  // If we have a path, try to render details for the file
  if (path) {
    return (
      <FileOrRepoDetailsCard
        isCollapsed={isCollapsed}
        path={safeDecodePath(path || '')}
      />
    );
  }

  return <RepositoryDetailsCard isCollapsed={isCollapsed} />;
};

export default SourceDetailsCard;
